import { useTranslation } from 'react-i18next';

import { Sheet, SheetContent, SheetDescription, SheetTitle } from '@/shared/ui/sheet';

import { OrbitaLogo } from '../brand/OrbitaLogo';

import { useShellStore } from './shellStore';
import { SidebarNav } from './Sidebar';

/** Sidebar as a drawer below the `lg` breakpoint. */
export function MobileNav() {
  const { t } = useTranslation('app');
  const open = useShellStore((s) => s.mobileNavOpen);
  const setOpen = useShellStore((s) => s.setMobileNavOpen);
  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent side="left" className="w-72 gap-0 bg-sidebar p-0">
        <SheetTitle className="sr-only">{t('nav.label')}</SheetTitle>
        <SheetDescription className="sr-only">{t('nav.description')}</SheetDescription>
        <div className="flex h-14 items-center px-4">
          <OrbitaLogo />
        </div>
        <div className="flex-1 overflow-y-auto px-3 pt-2 pb-6">
          <SidebarNav onNavigate={() => setOpen(false)} />
        </div>
      </SheetContent>
    </Sheet>
  );
}
